import { createAction } from '@reduxjs/toolkit';

export const ADD_EMPTY_ORDERS = 'orders/getEmptyOrders';

export const addEmptyArray = createAction(
    ADD_EMPTY_ORDERS,
    () => ({ payload: { orders: [] } }),
);
